import { createElement } from 'rax';
import { FieldElement } from '../field';
import Input from '../input';
export default class InputField extends FieldElement {
    renderControl() {
        return <Input {...this.getProps()}/>;
    }
}
InputField.displayName = 'InputField';
